import React, { useEffect } from 'react'

import { useAvailableCategories } from '../../../../hooks'

const StatisticTabs = ({ tab, onTabChange }) => {
  const { passedCategories: categories } = useAvailableCategories('passed')

  const handleTabClick = (newTab) => {
    onTabChange(newTab)
  }

  useEffect(() => {
    if (categories.length) {
      onTabChange(categories[0].slug)
    }
  }, [categories, onTabChange])

  const categoriesContent = categories.map((category) => {
    const isActive = tab === category.slug

    return (
      <button
        key={category.slug}
        className={`relative pb-[8px] text-[16px] leading-[19px] text-[#F67443] transition-opacity duration-200 ease after:absolute after:left-0 after:bottom-[-1px] after:w-full after:h-[2px] after:bg-[#F67443] ${isActive ? 'font-bold' : 'font-medium after:hidden opacity-70'}`}
        onClick={() => handleTabClick(category.slug)}
      >
        {category.name}
      </button>
    )
  })

  return (
    <div className="w-full mt-[10px] border-b-[#F6BD92] border-b-[1px] flex items-center gap-x-[12px]">
      {categoriesContent}
    </div>
  )
}

export default StatisticTabs
